import { Box, IconButton } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { setModalOpen } from 'store/ResponseTemplate/actions';
const PreviewTemplate = () => {
    const dispatch = useDispatch();
    const { selectedItem } = useSelector((params) => params.response);
    return (
        <>
            {selectedItem && selectedItem._id && (
                <>
                    <Box className="modal-header">
                        <h3>{selectedItem.question}</h3>
                        <IconButton
                            onClick={() => {
                                dispatch({ type: setModalOpen, modalOpen: false });
                            }}
                            className="modal-close"
                        >
                            <CloseOutlined className="icon-yellow-fill" />
                        </IconButton>
                    </Box>
                    <Box className="modal-content">
                        {selectedItem.response && (
                            <p style={{ fontSize: 15, textAlign: 'justify', marginBottom: '1em' }}>{selectedItem.response}</p>
                        )}
                    </Box>
                </>
            )}
        </>
    );
};

export default PreviewTemplate;
